import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import ExpenseForm, { ExpenseFormRef, ExpenseValues } from './ExpenseForm';

type CreateExpenseModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: ExpenseValues) => Promise<void>;
};

const CreateExpenseModal: React.FC<CreateExpenseModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
}: CreateExpenseModalProps) => {
  const { messages } = useTypedIntl();
  const formRef = useRef<ExpenseFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: ExpenseValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
      formRef.current?.reset();
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.addNewExpense']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <ExpenseForm formRef={formRef} onSubmit={handleSubmit} />
    </AppModalContainer>
  );
};

export default CreateExpenseModal;
